module.exports = "https://www.gc-pro.gnp.com.mx/d517ce932c3d40041c7f103a495a8508.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/user.svg
// module id = 8170
// module chunks = 0